<div class="success-container">
    <i *ngIf=showCloseButton class="fas fa-times close-button" (click)="close()"></i>
    <app-svg-icon name="bill-check"></app-svg-icon>
    <div class="success-title" translate>
        texts.Packages_Section_Success_Title </div>
    <div class="success-text" translate> texts.Packages_Section_Success_Text </div>
    <button class="button confirm-button" *ngIf="showConfirmButton" (click)="confirm()"
        translate>texts.buy_package_button</button>
</div>